import { ClearOutlined as ClearOutlinedIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { SkillChip } from '../../../design/components/skillChips/SkillChip';
import { useSkillDetailsQuery } from '../../query-hooks/skill-details';

type SkillFilterChipProps = {
    readonly id: string;
    readonly onRemoveSkill: (skillId: string) => void;
};

export const SkillFilterChip: FunctionComponent<SkillFilterChipProps> = ({ id, onRemoveSkill }) => {
    const { data: skill, isPending } = useSkillDetailsQuery(id);

    if (isPending || is.nullOrUndefined(skill)) {
        return null;
    }

    return (
        <Box key={skill.id} sx={{ display: 'flex' }}>
            <Grid alignItems="center" container={true} direction="row" display="flex">
                <Grid size="grow">
                    <SkillChip label={skill.title} skillId={skill.id} type={skill.skillType} />
                </Grid>
                <Grid size="auto">
                    <IconButton onClick={() => onRemoveSkill(skill.id)}>
                        <ClearOutlinedIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Box>
    );
};
